import { serviceMaker, methods, api } from "@/http/index.js";

export const getCountryCurrencyData = () =>
  serviceMaker(`/countrycurrency`, methods.GET, api.NGB);
export const deleteCountryCurrency = (id) =>
  serviceMaker(`/countrycurrency/${id}`, methods.DELETE, api.NGB);
export const getTemplateCountryCurrency = () =>
  serviceMaker(`/countrycurrency/template`, methods.GET, api.NGB);
export const createCountryCurrency = (data) =>
  serviceMaker(`/countrycurrency`, methods.POST, api.NGB, data);
export const editDataCountryCurrency = (id) =>
  serviceMaker(`/countrycurrency/${id}?template=true`, methods.GET, api.NGB);
export const updateCountryCurrency = (id, data) =>
  serviceMaker(`/countrycurrency/${id}`, methods.PUT, api.NGB, data);
export const getCountryCurrencyById = (id) =>
  serviceMaker(`/countrycurrency/${id}`, methods.GET, api.NGB);
